import { oz } from '@weft/utils';

export const INTEGRATION_PROVIDERS = Object.freeze({
  hubspot: 'Hubspot',
  stripe: 'Stripe',
  netSuite: 'NetSuite',
  salesforce: 'Salesforce',
  quickbooks: 'Quickbooks',
  slack: 'Slack',
});

export const IntegrationProvidersSchema = oz.nativeEnum(INTEGRATION_PROVIDERS);

export type IntegrationProviders = oz.infer<typeof IntegrationProvidersSchema>;